export default __webpack_public_path__ + "static/theoldhemp-b3e74958464c0b7e8691abeba59153df.png";